import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AppliedFilter, Filter, FilterConfig } from 'src/app/core/interfaces/filter.interface';
import { TableHeader, TableHeadersMeta, TableQuery } from 'src/app/core/interfaces/table.interface';
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../services/localization.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-list-layout-v1',
  templateUrl: './list-layout.component.html',
  styleUrl: './list-layout.component.scss'
})
export class ListLayoutComponent implements OnInit, OnChanges, OnDestroy {
  @Input({ required: true }) tableHeader: TableHeadersMeta;
  @Input({ required: true }) data: any[];
  @Input({ required: true }) loading: boolean;
  @Input({ required: true }) localKey: string;
  @Input({ required: true }) totalRecords: number = 0;
  @Input({ required: true }) selectStates: 'all' | 'some' | 'none';
  @Input() filterConfigs: FilterConfig[];
  @Output() loadData = new EventEmitter<TableQuery>();
  // TODO: should change this later :)
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSelectAll = new EventEmitter<boolean>();

  currentOrderBy?: string;
  currentSearch: string = '';

  effectiveFilterConfigs: FilterConfig[] | undefined;

  private destroy$ = new Subject<void>();

  currentPage = 1;
  pageSize = 10;
  pageSizes = [5, 10, 20, 50, 100];

  appliedFilters: AppliedFilter[] = [];

  constructor(
    private translate: TranslateService,
    private localizationService: LocalizationService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterConfigs'] || changes['tableHeader']) {
      this.buildEffectiveFilterConfigs();
    }
  }

  loadingPage(input: {
    currentPage: number;
    pageSize: number;
  }) {
    console.log("loading page");
    this.currentPage = input.currentPage;
    this.pageSize = input.pageSize;
    this.loadDataHelper();
    // this.savePropsToLocalstroge();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  search(value: string) {
    this.currentSearch = value;
    this.loadDataHelper();
    // this.savePropsToLocalstroge();
  }

  onSort(value: TableHeader) {
    let key = value.key;
    if (typeof key === 'function') {
      key = key();
    }

    const keyWithAsc = `${key} asc`;
    const keyWithDesc = `${key} desc`;

    if (!this.currentOrderBy || this.currentOrderBy !== keyWithAsc && this.currentOrderBy !== keyWithDesc) {
      // لا يوجد ترتيب أو ترتيب على عمود آخر -> ترتيب تصاعدي
      this.currentOrderBy = keyWithAsc;
    } else if (this.currentOrderBy === keyWithAsc) {
      // ترتيب تصاعدي -> ترتيب تنازلي
      this.currentOrderBy = keyWithDesc;
    } else if (this.currentOrderBy === keyWithDesc) {
      // ترتيب تنازلي -> إزالة الترتيب
      this.currentOrderBy = undefined;
    }
    this.loadDataHelper();
    // this.savePropsToLocalstroge();
  }

  loadDataHelper() {
    this.loadData.emit({
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      currentOrderBy: this.currentOrderBy,
      currentSearch: this.currentSearch,
      filters: this.appliedFilters,
    });
  }

  updateFilters(filters: AppliedFilter[]) {
    this.appliedFilters = filters;
    this.loadDataHelper();
    this.saveFiltersToLocalStorage();
  }

  private saveFiltersToLocalStorage(): void {
    try {
      localStorage.setItem(`${this.localKey}_currentFilter`, JSON.stringify(this.appliedFilters));
    } catch {
      // ignore storage errors
    }
  }

  private restoreFiltersFromLocalStorage(): boolean {
    try {
      const raw = localStorage.getItem(`${this.localKey}_currentFilter`);
      if (!raw) return false;
      const parsed = JSON.parse(raw) as AppliedFilter[];
      if (Array.isArray(parsed) && parsed.length > 0) {
        this.appliedFilters = parsed;
        // حذف الفلتر من localStorage بعد قراءته وتطبيقه حتى لا يبقى مؤثراً في زيارات لاحقة
        localStorage.removeItem(`${this.localKey}_currentFilter`);
        return true;
      }
    } catch {
      // ignore parse/storage errors
    }
    return false;
  }

  private restoreSearchTermFromLocalStorage(): boolean {
    try {
      const searchTerm = localStorage.getItem(`${this.localKey}_searchTerm`);
      if (searchTerm) {
        this.currentSearch = searchTerm;
        // حذف القيمة بعد قراءتها حتى لا تبقى مؤثرة في زيارات لاحقة
        localStorage.removeItem(`${this.localKey}_searchTerm`);
        return true;
      }
    } catch {
      // ignore
    }
    return false;
  }

  // savePropsToLocalstroge() {
  //   localStorage.setItem(`${this.localKey}_currentPage`, this.currentPage.toString());
  //   localStorage.setItem(`${this.localKey}_pageSize`, this.pageSize.toString());

  //   // if (this.appliedFilters) {
  //   //   localStorage.setItem(`${this.localKey}_currentFilter`, JSON.stringify(this.appliedFilters));
  //   // } else {
  //   //   localStorage.removeItem(`${this.localKey}_currentFilter`);
  //   // }

  //   if (this.currentOrderBy) {
  //     localStorage.setItem(`${this.localKey}_currentOrderBy`, this.currentOrderBy);
  //   } else {
  //     localStorage.removeItem(`${this.localKey}_currentOrderBy`);
  //   }

  //   localStorage.setItem(`${this.localKey}_currentSearch`, this.currentSearch);
  // }

  // getPropsFromLocalstroge() {
  //   const currentPage = localStorage.getItem(`${this.localKey}_currentPage`);
  //   if (currentPage) {
  //     this.currentPage = parseInt(currentPage);
  //   }

  //   const pageSize = localStorage.getItem(`${this.localKey}_pageSize`);
  //   if (pageSize) {
  //     this.pageSize = parseInt(pageSize);
  //   }

  //   // const currentFilter = localStorage.getItem(`${this.localKey}_currentFilter`);
  //   // if (currentFilter) {
  //   //   this.appliedFilters = JSON.parse(currentFilter);
  //   // }

  //   const currentOrderBy = localStorage.getItem(`${this.localKey}_currentOrderBy`);
  //   if (currentOrderBy) {
  //     this.currentOrderBy = currentOrderBy;
  //   }

  //   const currentSearch = localStorage.getItem(`${this.localKey}_currentSearch`);
  //   if (currentSearch) {
  //     this.currentSearch = currentSearch;
  //   }

  //   this.loadDataHelper();
  // }

  ngOnInit(): void {
    const hasFilters = this.restoreFiltersFromLocalStorage();
    const hasSearchTerm = this.restoreSearchTermFromLocalStorage();
    this.buildEffectiveFilterConfigs();
    
    // إذا كان هناك searchTerm أو filters، نرسل loadData event فوراً
    if (hasSearchTerm || hasFilters) {
      // استخدام setTimeout لضمان أن الـ parent component جاهز
      setTimeout(() => {
        this.loadDataHelper();
      }, 0);
    }

    this.localizationService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.buildEffectiveFilterConfigs();
      });
  }

  ngOnDestroy(): void {
    // حذف الفلتر من localStorage عند مغادرة الصفحة
    try {
      localStorage.removeItem(`${this.localKey}_currentFilter`);
    } catch {
      // ignore storage errors
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildEffectiveFilterConfigs(): void {
    this.buildAutoFilterConfigs();
  }

  private buildAutoFilterConfigs(): FilterConfig[] {
    if (!this.tableHeader || !this.tableHeader.headers) {
      return [];
    }

    const headers = this.tableHeader.headers.filter((header) => !!header.key && !!header.label && !header.isHiddenFromFilter);

    const configs: FilterConfig[] = headers.map((header) => {
      const key = typeof header.key === 'function' ? header.key() : header.key as string;
      const translationKey = header.label;

      const labelEn = this.getTranslationForLang('en', translationKey);
      const labelAr = this.getTranslationForLang('ar', translationKey);

      return {
        key,
        type: 'text',
        label: labelEn,
        labelAr: labelAr,
      };
    });

    this.effectiveFilterConfigs = this.mergeConfigs(configs);
    return configs;
  }

  private getTranslationForLang(lang: string, key: string): string {
    const translationsForLang = (this.translate.translations as Record<string, unknown>)[lang];
    const resolved = this.resolveNestedTranslation(translationsForLang, key);
    return resolved ?? key;
  }

  private resolveNestedTranslation(
    translations: unknown,
    fullKey: string
  ): string | undefined {
    if (!translations || typeof fullKey !== 'string' || fullKey.length === 0) {
      return undefined;
    }

    const parts = fullKey.split('.');
    let current: unknown = translations;

    for (const part of parts) {
      if (typeof current === 'object' && current !== null && Object.prototype.hasOwnProperty.call(current, part)) {
        current = (current as Record<string, unknown>)[part];
      } else {
        return undefined;
      }
    }

    return typeof current === 'string' ? current : undefined;
  }

  private mergeConfigs(autoConfigs: FilterConfig[]): FilterConfig[] {
    const manualConfigs = this.filterConfigs ?? [];

    if (autoConfigs.length === 0 && manualConfigs.length === 0) {
      return undefined as any;
    }

    const mergedConfigs = new Map<string, FilterConfig>();

    autoConfigs.forEach((config) => {
      mergedConfigs.set(config.key, config);
    });

    manualConfigs.forEach((config) => {
      mergedConfigs.set(config.key, config);
    });

    return Array.from(mergedConfigs.values());
  }
}
